import React from "react";
import { MONTH_NAMES } from "../../../../lib/enums";
import { NewsDay } from "../../../../lib/types";

interface IProps {
  day: number;
  activeDay: number;
  month: number;
  year: number;
  firstMonth: boolean;
  lastMonth: boolean;
  newsMonth: {[key: number]: NewsDay};
  changeDay: (day: number) => void;
  moveCalendar: (direction: string) => void;
}

const NewsCalendar = ({
  activeDay,
  month,
  year,
  firstMonth,
  lastMonth,
  newsMonth,
  changeDay,
  moveCalendar
}: IProps) => {
  let weekIndex = 0;
  const weeks: NewsDay[][] = [];
  Object.values(newsMonth).map((newsDay, index) => {
    const weekDay = newsDay.weekDay || newsDay.numericWeekDay;

    if (!weeks[weekIndex]) {
      weeks[weekIndex] = [];
    }
    weeks[weekIndex][Number.parseInt(weekDay, 10) || 7] = newsDay;
    weeks[weekIndex][Number.parseInt(weekDay, 10) || 7]
      .monthDay = weeks[weekIndex][Number.parseInt(weekDay, 10) || 7]
        .monthDay || (index + 1).toString();
    if (weekDay === "0") {
      weekIndex += 1;
      weeks[weekIndex] = [];
    }

    return null;
  });

  return (
    <div className="col-md-offset-2 col-md-8">
      <h3 className="text-center h3 table-title">
        {!firstMonth
          ? <a
            onClick={() => moveCalendar("bck")}
            className="arrow-btn prev"
          /> : <></>}
        {MONTH_NAMES[month]} {year}
        {!lastMonth
          ? <a
            onClick={() => moveCalendar("frw")}
            className="arrow-btn next"/> : <></>}
      </h3>
      <table className="table table-calendar">
        <thead>
        <tr>
          <th>Mo</th>
          <th>Tu</th>
          <th>We</th>
          <th>Th</th>
          <th>Fr</th>
          <th>Sa</th>
          <th>Su</th>
        </tr>
        </thead>
        <tbody>
        {weeks.map(week => <tr>
          {Array(7).fill("").map((_, index) => (week[index + 1]
            ? <td
                className={`${week[index + 1].monthDay === new Date().getDate().toString(10)
                  && month === new Date().getMonth() + 1 ? "today" : ""} 
                ${week[index + 1].gameDay === activeDay ? "active" : ""}`}
            >
              {week[index + 1] && week[index + 1].gameDay
                ? <a className={"link"} onClick={() => changeDay(week[index + 1].gameDay)}>
                  {week[index + 1].monthDay}
                </a>
                : <>{week[index + 1].monthDay}</>
              }
              <small>({week[index + 1].weekDay ? '-' : week[index + 1].gameDay})</small>
            </td>
            : <td>&nbsp;</td>
          ))}
        </tr>)
        }
        </tbody>
      </table>
    </div>
  )
}

export default NewsCalendar;
